import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TxNativeModule } from '@transifex/angular';
import { PackageFeature } from '@twaice-fe/frontend/shared/services';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { EmptySolutionComponent } from '../empty-solution/empty-solution.component';

const FEATURE_ILLUSTRATIONS: Record<PackageFeature, string> = {
  [PackageFeature.Performance]: 'assets/img/illustrations/temperature_not_available.svg',
  [PackageFeature.RecoverableEnergy]: 'assets/img/illustrations/recoverable_not_available.svg',
  [PackageFeature.PenaltyRisk]: 'assets/img/illustrations/penalty_not_available.svg',
  [PackageFeature.Degradation]: 'assets/img/illustrations/degredation_not_available.svg',
  [PackageFeature.Anomalies]: 'assets/img/illustrations/anomalies_not_available.svg',
  [PackageFeature.ErrorCodes]: 'assets/img/illustrations/error_codes_not_available.svg',
};

const FALLBACK_ILLUSTRATION = 'assets/img/illustrations/energy_analytics_empty.svg';

/**
 * Not included page shown in place of a feature the customer's product package does not
 * include. Reached by falling through a `packageIncludes()` `canMatch` guard, so the
 * URL of the gated page is preserved.
 *
 * The feature is read from the route's `data.feature`.
 */
@Component({
  selector: 'twaice-fe-feature-not-included',
  imports: [CommonModule, EmptySolutionComponent, NzButtonModule, NzTypographyModule, TxNativeModule],
  templateUrl: './feature-not-included.component.html',
})
export class FeatureNotIncludedComponent {
  protected readonly illustration = this.resolveIllustration(inject(ActivatedRoute));

  private resolveIllustration(route: ActivatedRoute): string {
    // for `**` fallback routes the feature is declared on the parent, and inherited here
    // because the router is configured with paramsInheritanceStrategy: 'always'
    const feature: PackageFeature | undefined = route.snapshot.data['feature'];

    if (!feature) {
      console.error('[FeatureNotIncludedComponent] No feature provided via route data');
      return FALLBACK_ILLUSTRATION;
    }

    return FEATURE_ILLUSTRATIONS[feature] ?? FALLBACK_ILLUSTRATION;
  }
}
